export const menuTitle = { title: "SMU/SMK", label: "SMU/SMK" }
  